var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgK8SNamespace = function SvgK8SNamespace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h3.833c.217 0 .427.07.6.2l1.734 1.3H14a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1M5.833 2H2L2 14h12V3.5H7.833z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-6 7V6h6v6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
export default SvgK8SNamespace;